var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ background: _vm.skyGradient }),attrs:{"id":"sky"}})
}
var staticRenderFns = []

export { render, staticRenderFns }